"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Checkbox_1 = require("@material-ui/core/Checkbox");
var FormControlLabel_1 = require("@material-ui/core/FormControlLabel");
var Theme_1 = require("./Theme");
exports.default = (function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? "" : _c, _d = _a.color, color = _d === void 0 ? "primary" : _d;
    return (React.createElement(Theme_1.default, { color: color },
        React.createElement(FormControlLabel_1.default, { control: React.createElement(Checkbox_1.default, { checked: value, onChange: onChange, color: color }), label: label })));
});
//# sourceMappingURL=FormControlCheckbox.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/components/dist/theme/mdb/FormControlCheckbox.js
// module id = 2227
// module chunks = 0